import React from "react";
import { motion } from "framer-motion";

// Reusable editorial section header
export function ChapterHead({ eyebrow, title, roman, dark = false }) {
    return (
        <div className="mb-16 md:mb-24">
            <div className="flex items-baseline gap-6">
                {roman && (
                    <motion.span
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.8 }}
                        className="font-didone italic text-lg md:text-2xl"
                        style={{ color: "#C9A96A" }}
                    >
                        {roman}
                    </motion.span>
                )}
                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.8, delay: 0.1 }}
                    className="font-micro text-[10px] md:text-xs"
                    style={{ letterSpacing: "0.4em", color: dark ? "#F4EFE6" : "#0B0B0B", opacity: 0.6 }}
                >
                    {eyebrow}
                </motion.div>
            </div>
            <motion.h2
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 1.1, delay: 0.15, ease: [0.7, 0, 0.2, 1] }}
                className="mt-6 font-didone font-normal text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight"
                style={{ color: dark ? "#F4EFE6" : "#0B0B0B" }}
            >
                {title}
            </motion.h2>
            <motion.div
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 1.2, delay: 0.4, ease: [0.7, 0, 0.2, 1] }}
                className="mt-8 h-px w-32"
                style={{ background: "#C9A96A", transformOrigin: "left" }}
            />
        </div>
    );
}

// Reveal wrapper for body content
export function Reveal({ children, delay = 0, y = 30, className = "" }) {
    return (
        <motion.div
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, delay, ease: [0.7, 0, 0.2, 1] }}
            className={className}
        >
            {children}
        </motion.div>
    );
}

// Full chapter shell
export function ChapterShell({ id, slug, dark = false, children, className = "" }) {
    return (
        <section
            id={slug}
            data-testid={`chapter-${slug}`}
            data-chapter={slug}
            className={`chapter chapter-shell ${dark ? "dark" : ""} ${className}`}
            style={{
                background: dark ? "#0B0B0B" : "#F4EFE6",
                color: dark ? "#F4EFE6" : "#0B0B0B",
            }}
        >
            <div className="column-12">{children}</div>
        </section>
    );
}
